import { GET_RECENT_CONTACTS } from '../types/index';

export default (contacts = [], action) => {
  switch (action.type) {
    case GET_RECENT_CONTACTS:
      return action.payload;
    default:
      return contacts;
  }
}